import "./TyreLoader.css";

const TyreLoader = () => {
  return (
    <div className="section-loader">
      <div className="tyre-loader-container">
        {/* Tyre image spinning */}
        <div className="tyre-spin-wrapper">
          <img
            src="/assets/img/GIF/tireimg.png"
            alt="Loading..."
            className="tyre-real-img"
            draggable={false}
          />
        </div>

        {/* Ground shadow */}
        <div className="tyre-ground-shadow" />

        {/* Loading text */}
        <div className="tyre-loading-text">
          <span className="tyre-dot" style={{ animationDelay: "0.55s" }}>.</span>
          <span className="tyre-dot" style={{ animationDelay: "0.7s" }}>.</span>
          <span className="tyre-dot" style={{ animationDelay: "0.85s" }}>.</span>
        </div>
      </div>
    </div>
  );
};

export default TyreLoader;
